/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Button,
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import chplanActions from 'loraactions/chplan';
import PageLoading from 'loracoms/PageLoading';
import Toolbar from 'loracoms/Toolbar';
import { allSuccess } from 'lorautils/api/status';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ChannelList from './coms/ChannelList';
import DeleteChannelPlanModal from '../DeleteChannelPlanModal';


const propTypes = {
  channelPlan: React.PropTypes.object.isRequired,
  id: React.PropTypes.string.isRequired,
  getChannelPlan: React.PropTypes.func.isRequired,
  getChannelDefines: React.PropTypes.func.isRequired,
  getDataRates: React.PropTypes.func.isRequired,
  chDefs: React.PropTypes.object.isRequired,
  dataRates: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class ChannelPlanDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelPlan: props.channelPlan,
      chDefs: props.chDefs,
      dataRates: props.dataRates,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.banddetail.detailview');
  }

  componentWillMount() {
    const { id, getChannelPlan } = this.props;
    getChannelPlan(id);
  }

  componentWillReceiveProps(nextProps) {
    const { channelPlan, chDefs, dataRates } = nextProps;
    if (channelPlan !== this.props.channelPlan) {
      this.setState({ channelPlan });
      if (channelPlan.status === 'success') {
        const { band } = channelPlan.data;
        const { getChannelDefines, getDataRates } = this.props;
        getChannelDefines(band);
        getDataRates(band);
      }
    }
    if (chDefs !== this.props.chDefs) {
      this.setState({ chDefs });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates });
    }
  }

  renderToolbar() {
    const { pushState } = this.props;
    const { channelPlan: { status, data: { name } = {} } } = this.state;

    const breadcrumb = [{
      onClick: () => pushState('/network/chplans'),
      content: this.intlMsg.msg('toolbar.firstnav'),
    }, {
      content: <Nvl val={name} status={status} />,
      active: true,
    }];
    const delBtn = (
      <Button bsStyle="aisz-danger" onClick={() => this.setState({ showDelete: true })}>
        {this.intlMsg.msg('deletebtn')}
      </Button>
    );
    return (
      <Toolbar
        breadcrumb={breadcrumb}
        rightTools={[{ input: delBtn }]}
      />
    );
  }

  render() {
    const { channelPlan, chDefs, dataRates, showDelete = false } = this.state;
    if (!allSuccess(channelPlan, chDefs, dataRates)) {
      return <PageLoading />;
    }

    const { reserved = [] } = chDefs.data;

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ChannelList
              channelPlan={channelPlan.data}
              reserved={reserved}
              datarates={dataRates.data}
            />
          </Col>
        </Row>
        <DeleteChannelPlanModal
          show={showDelete}
          channelPlan={channelPlan.data}
          onHide={() => this.setState({ showDelete: false })}
        />
      </Grid>
    );
  }
}

ChannelPlanDetail.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.params.id,
  channelPlan: state.chplan.getChannelPlan,
  chDefs: state.chplan.getChannelDefines,
  dataRates: state.chplan.getDataRates,
});

const mapDispatchToProps = {
  getChannelPlan: chplanActions.getChannelPlan,
  getChannelDefines: chplanActions.getChannelDefines,
  getDataRates: chplanActions.getDataRates,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ChannelPlanDetail));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/ChannelPlanDetail/index.jsx